let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ePgeS")).then(() => parcelRequire('6ztoV'));